import * as Form from '../../Form';
import { AdditionalInfoSectionBase } from '../../dapp-form/sections/AdditionalInfoSectionBase';
import type { FormState, NewDappInputChangeEvent } from '../types';

interface AdditionalInfoSectionProps {
  formData: FormState;
  onInputChange: (event: NewDappInputChangeEvent) => void;
}

export function AdditionalInfoSection({
  formData,
  onInputChange,
}: AdditionalInfoSectionProps) {
  return (
    <AdditionalInfoSectionBase
      formData={formData}
      onInputChange={onInputChange}
      websiteField={
        <Form.UrlInput
          label="App Website"
          explanation="This will display on the app detail page and can link to your app or your company website."
          name="appWebsite"
          placeholder="https://"
          defaultValue={formData.appWebsite}
          validateHttps={true}
        />
      }
      contactEmailExplanation="Primary contact for the Solana dApp Store"
      contactEmailRequired={true}
      supportEmailExplanation="The email that will receive support emails."
      supportEmailRequired={true}
    />
  );
}
